require('./brokerRightsBuySuccessStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const {
    FIRST_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    EURO_TEXT
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @utilities
const DateHelper = require('utilities/dateHelper');
const { getFormattedString, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class BrokerRightsBuySuccessStep extends React.Component {
    render() {
        const { immBrokerRightsBuy, immCorporatesOperations } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get(
            'selectedCorporateOperationIndex'
        );
        const selectedCorporateOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            selectedCorporateOperationIndex
        ]);
        const title = formatText('broker-rightsBuySuccessTitle');
        const subTitle = formatText('broker-rightsBuySuccessSubtitle', [
            immBrokerRightsBuy.get('orderNumber')
        ]);
        const mainButtonLabel = formatText('broker-rightsBuySuccessMainButtonLabel');
        const mainButtonLink = `/myprofile/broker`;
        const mainButton = {
            label: mainButtonLabel,
            url: mainButtonLink,
            modifier: 'secondary'
        };
        const secondaryButtonLabel = formatText('broker-rightsBuySuccessSecondaryButtonLabel');
        const secondaryButtonLink = `/myprofile/broker/corporatesOperations`;
        const secondaryButton = {
            label: secondaryButtonLabel,
            url: secondaryButtonLink
        };
        const rightsQuantity = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
        const availableRights = Number(rightsQuantity);
        const limitedValue = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
        const formattedLimitedValue = getFormattedString({
            amount: limitedValue,
            decimalsLength: BROKER_TYPE_RIGHT_NEW_DECIMALS,
            currency: EURO_TEXT // @hardcoded
        });
        const orderTypeOption = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
        const validityDate = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'validityDate']);
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const fullContractNumber =
            CHARGE_ACCOUNT_PREFIX +
            selectedContract.getIn(['cuenta', 'digitodecontrol']) +
            selectedContract.getIn(['cuenta', 'fullNumber']);
        const plainAmountObject = getPlainAmountObject(selectedContract.getIn(['associatedAccount','balance']));
        let orderTypeText;

        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderTypeText = formatText('broker-rightsBuyToMarketOrderType');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderTypeText = formatText('broker-rightsBuyForTheBestOrderType');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                orderTypeText = formatText('broker-rightsBuySuccessLimitedOrderType', [formattedLimitedValue]);
                break;
        }

        return (
            <article className="broker-rights-buy-success row no-gutter">
                <h2 className="broker-rights-buy-success__info-operation-end">
                    <FormattedText value="broker-rightsBuySuccessOperationEnd" />
                </h2>
                <div className="col-xs-12">
                    <WizardSuccess
                        successMessage={title}
                        successMessageChildren={subTitle}
                        mainButton={mainButton}
                        secondaryButton={secondaryButton}
                    >
                        <section className="broker-rights-buy-success__info-section row">
                            <div className="col-lg-4 broker-rights-buy-success__titles-container-left">
                                <div>
                                    <OKInformativeList>
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsBuyValueLabel')}
                                            bodyText={selectedCorporateOperation.get(
                                                'descriptionValue'
                                            )}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsBuyContractLabel')}
                                            bodyText={selectedContract.get('walletAccountType')}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        >
                                            <div className="broker-rights-buy-success__stock-container-info">
                                                <div className="broker-rights-buy-success__stock-container-info--item">
                                                    <FormattedText
                                                        value="broker-rightsBuySuccessStepContractNumber"
                                                        injectedStrings={[fullContractNumber]}
                                                    />
                                                    <br />
                                                    <FormattedText
                                                        value="broker-rightsBuySuccessStepHolder"
                                                        injectedStrings={[
                                                            selectedContract.get('owner')
                                                        ]}
                                                    />
                                                </div>
                                                <div className="broker-rights-buy-success__stock-container-info--item">
                                                    <FormattedText
                                                        value="broker-rightsBuySuccessAssociatedAccount"
                                                        injectedStrings={[
                                                            selectedContract.getIn([
                                                                'associatedAccount',
                                                                'number'
                                                            ])
                                                        ]}
                                                    />
                                                    <br />
                                                    <FormattedText value="broker-rightsBuyBalancePrefix" />
                                                    <OneLineSymbolAmount
                                                        amountObject={plainAmountObject}
                                                        language={getLanguage()}
                                                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                                    />
                                                    <FormattedText value="broker-rightsBuyBalanceSuffix" />
                                                </div>
                                            </div>
                                        </OKInformativeListItem>
                                    </OKInformativeList>
                                </div>
                            </div>

                            <div className="col-lg-8 broker-rights-buy-success__titles-container-right">
                                <div>
                                    <OKInformativeList>
                                        <OKInformativeListItem
                                            title={formatText(
                                                'broker-rightsBuyAvailableRightsLabel'
                                            )}
                                            bodyText={availableRights}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText(
                                                'broker-rightsBuyTermOfValidityLabel'
                                            )}
                                            bodyText={DateHelper.buildFormattedDate(
                                                validityDate,
                                                formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)
                                            )}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsBuyOrderTypeLabel')}
                                            bodyText={orderTypeText}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                    </OKInformativeList>
                                </div>
                            </div>
                        </section>
                    </WizardSuccess>
                </div>
            </article>
        );
    }
}

BrokerRightsBuySuccessStep.propTypes = {
    immBrokerRightsBuy: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired
};

module.exports = BrokerRightsBuySuccessStep;
